<!-- gmail-non-eu-desktop-01 preview — the Gmail ad on desktop, toggle-able
     between its two real states: the collapsed inbox row, and the expanded
     message a recipient lands on after clicking it. -->
<div class="gm-state-toggle d-flex flex-row justify-content-center">
  <button
    type="button"
    class="gm-state-tab"
    [class.active]="view === 'closed'"
    (click)="selectView('closed')"
  >
    Closed
  </button>
  <button
    type="button"
    class="gm-state-tab"
    [class.active]="view === 'open'"
    (click)="selectView('open')"
  >
    Open
  </button>
</div>

<app-desktop-frame>
  <div class="gm-desktop-page">
    <!-- START: Gmail app top bar — shared by both states -->
    <div class="gm-desktop-topbar d-flex flex-row align-items-center">
      <i class="bi bi-list gm-desktop-icon"></i>
      <div class="gm-desktop-logo d-flex flex-row align-items-center">
        <i class="bi bi-envelope-fill gm-desktop-logo-icon"></i>
        <span class="gm-desktop-logo-text">Gmail</span>
      </div>
      <div class="gm-desktop-searchbar d-flex flex-row align-items-center justify-content-between">
        <i class="bi bi-search gm-desktop-search-icon"></i>
        <i class="bi bi-sliders gm-desktop-filter-icon"></i>
      </div>
    </div>
    <!-- END: Gmail app top bar -->

    <!-- START: Collapsed inbox list -->
    <div class="gm-desktop-inbox" *ngIf="view === 'closed'">
      <div class="gm-desktop-tabs d-flex flex-row">
        <div class="gm-desktop-tab active">
          <i class="bi bi-inbox"></i>
          <span class="gm-desktop-tab-bar placeholder"></span>
        </div>
        <div class="gm-desktop-tab">
          <i class="bi bi-tag"></i>
          <span class="gm-desktop-tab-bar placeholder"></span>
        </div>
        <div class="gm-desktop-tab">
          <i class="bi bi-people"></i>
          <span class="gm-desktop-tab-bar placeholder"></span>
        </div>
      </div>

      <!-- START: Real ad -->
      <div class="gm-desktop-row d-flex flex-row align-items-center">
        <i class="bi bi-star gm-desktop-row-star"></i>
        <span class="gm-desktop-row-sender">Valamar</span>
        <div class="gm-desktop-row-subject-col">
          <span class="gm-desktop-row-sponsored">Sponsored</span>
          <span class="gm-desktop-row-sep">·</span>
          <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="gm-desktop-row-subject">
            {{ data.headlines[0] || "Your headline appears here" }}
          </a>
          <span class="gm-desktop-row-snippet"> - {{ data.descriptions[0] || "Your description appears here" }}</span>
        </div>
        <i class="bi bi-three-dots-vertical gm-desktop-row-menu"></i>
      </div>
      <!-- END: Real ad -->
    </div>
    <!-- END: Collapsed inbox list -->

    <!-- START: Expanded message -->
    <div class="gm-desktop-message" *ngIf="view === 'open'">
      <div class="gm-desktop-toolbar d-flex flex-row align-items-center">
        <i class="bi bi-arrow-left gm-desktop-icon"></i>
        <i class="bi bi-archive gm-desktop-toolbar-icon"></i>
        <i class="bi bi-info-circle gm-desktop-toolbar-icon"></i>
        <i class="bi bi-folder2 gm-desktop-toolbar-icon"></i>
      </div>

      <div class="gm-desktop-sender d-flex flex-row align-items-center">
        <img *ngIf="data.logo" class="gm-desktop-sender-logo" [src]="data.logo" alt="" />
        <span *ngIf="!data.logo" class="gm-desktop-sender-logo logo-empty" aria-hidden="true"></span>
        <span class="gm-desktop-sender-name">Valamar</span>
      </div>

      <i class="bi bi-three-dots-vertical gm-desktop-message-menu"></i>

      <!-- START: Real ad -->
      <div class="gm-desktop-ad">
        <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="gm-desktop-creative-link">
          <img *ngIf="creativeImage" class="gm-desktop-creative-image" [src]="creativeImage" alt="" />
          <div *ngIf="!creativeImage" class="gm-desktop-creative-image creative-missing">{{ missingDimensionLabel }}</div>
        </a>
        <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="gm-desktop-headline">
          {{ data.headlines[0] || "Your headline appears here" }}
        </a>
        <div class="gm-desktop-desc">
          {{ data.descriptions[0] || "Your description appears here" }}
        </div>
        <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="gm-desktop-cta">
          <span class="gm-desktop-cta-label">{{ data.ctaText || "Your call to action" }}</span>
        </a>
      </div>
      <!-- END: Real ad -->
    </div>
    <!-- END: Expanded message -->
  </div>
</app-desktop-frame>
